import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/root/_services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/root/_services/authentication.service';
import { AlertService } from 'src/app/root/_services/alert.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-activate',
	templateUrl: './activate.component.html',
	styleUrls: ['./activate.component.scss']
})
export class ActivateComponent implements OnInit {

	error: boolean = false;
	error2: boolean = false;
	sub: any;

	constructor(
		private userService: UserService,
		private route: ActivatedRoute,
		private authService: AuthenticationService,
		private alertService: AlertService,
		private translateService: TranslateService
	) { }

	activate(token: string) {

		this.userService.activate(token).subscribe(
			data => {
				if (data.status == "OK" && data.result.jwt)
					this.authService.afterLogin(data, false, false, null);
				else if (data.status == "OK")
					this.error2 = true;
				else
					this.error = true;
			}
		);

	}

	ngOnInit() {
		this.sub = this.route.params.subscribe(params => {
			this.activate(params['token']);
		});
	}

	ngOnDestroy() {
		this.sub.unsubscribe();
	}

}
